// =========================
// INDEX.JS
// =========================
import App from './App.js';

// Shoelace bundle import
import '@shoelace-style/shoelace/dist/shoelace.js';

// Importing custom components
import './components/popin-side-nav.js';
import './components/popin-top-bar.js';
import './components/popin-post.js';
import './components/popin-poster.js';
import './components/popin-guide.js';
import './components/popin-search-grid.js';
import './components/popin-supplier-card.js';
import './components/popin-event-card.js';
import './components/popin-user-card.js';

// Importing main styles
import './scss/master.scss';

document.addEventListener('DOMContentLoaded', () => {
  App.init();
});
